import { combineReducers } from "@reduxjs/toolkit"
//reducers
import { routerReducer as router } from "./middlewares/router"
import { reducer as user } from "./user"

export default combineReducers({
  router,
  user,
})
